import immutableStore from 'alt-utils/lib/ImmutableUtil';
import immutable from 'immutable';

import alt from 'components/Dispatcher';
import CrmSyncActions from 'actions/crm/CrmSyncActions';
import CallCrmSupportsCloudSource from 'sources/crm/CallCrmSupportsCloudSource';

/**
 * CrmSupportsCloudStore is a ReactJS store that links <CallSyncCRMDialog/> with a backend source that keeps track of
 * whether the current user's account supports CRM sync or not
 */
@immutableStore
class CrmSupportsCloudStore {
  constructor() {
    this.state = immutable.Map({
      synced: false,
      supportsCrmSync: false,
    });
    this.bindActions(CrmSyncActions);
    this.registerAsync(CallCrmSupportsCloudSource);
  }

  /** Reset this.state.get('synced') to false so that the next time this store is called, it will update the
   *  supportsCrmSync value again using the backend
   */
  onResetSupportsCloudSynced() {
    const state = this.state.set('synced', false);
    this.setState(state);
  }

  /** Initiate a request to obtain the metadata about the crm cloud support status of the current user */
  onCrmSupportsCloud() {
    if (!this.state.get('synced')) {
      setImmediate(() => {
        this.getInstance().crmSupportsCloud();
      });
    }
  }

  /**
   * Update this.state.get('supportsCrmSync') using server-side response
   * @param {Object} resp Server-side response
   */
  onCrmSupportsCloudSuccess(resp) {
    let state = this.state.set('supportsCrmSync', resp.data.supported);
    state = state.set('synced', true);
    this.setState(state);
  }
}

export default alt.createStore(CrmSupportsCloudStore, 'CrmSupportsCloudStore');
